import Parameter from "./Parameter"
import * as Effects from "./effects/all";
import { EventEmitter } from 'events';

class BaseChannel extends EventEmitter {

	constructor(path) {
		super();
		this.path = path;
		this.gain = new Parameter({
			max: 6,
			min: -20,
			step: 1,
			value: 0,
			path: path + "_PARAM_GAIN",
			name: "Level",
			scale: "linear",
			internalScale: "10log10"
		});
		this.pan = new Parameter({
			min: -1,
			max: 1,
			step: 0.1,
			path: path + "_PARAM_PAN",
			name: "L/R"
		});

		this.effects = [];
		this.nextId = 0;
	}

	rehydrate(state) {
		var effectData, effect;

		this.effects = [];

		this.gain.setValue(state.gain);
		this.pan.setValue(state.pan);
		this.nextId = state.nextId || 0;

		if(state.effects) {
			for(var i = 0, len = state.effects.length; i < len; i++) {
				effectData = state.effects[i];
				if(Effects[effectData.type]) {
					if(effectData.path) {
						effect = new Effects[effectData.type](effectData.path, effectData.number);
					} else {
						effect = new Effects[effectData.type](this.path + "_EFFECT_" + this.nextId, this.nextId++);
					}

					effect.rehydrate(effectData);
					this.effects.push(effect);
				}
			}
		}
	}

	dehydrate() {
		return {
			gain: this.gain.value || 0,
			pan: this.pan.value || 0,
			effects: this.effects.map(function(effect){
				return effect.dehydrate();
			}),
			nextId: this.nextId
		};
	}

	addEffect(type){
		if(Effects[type]) {
			this.effects.push(new Effects[type](this.path + "_EFFECT_" + this.nextId, this.nextId++));
		}
	}

	removeEffect(number) {
		if(number < 0) return;
		this.effects.splice(number, 1);
	}

}

export default BaseChannel;
